import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { StaffService } from 'src/app/services/staff/staff.service';
import { MatDialog, MatSnackBar, MatTableDataSource, MatPaginator, MatSort, MatSidenav } from '@angular/material';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { UtilityService } from 'src/app/services/utility.service';
import { FilterService } from 'src/app/services/filter.service';
import { competencyStatusLists } from '../../_models/staticArray'
import { AssetService } from 'src/app/services/asset.service';
import { CompetenciesService } from 'src/app/services/competencies.service';

@Component({
  selector: 'app-staff-competency-list',
  templateUrl: './staff-competency-list.component.html',
  styleUrls: ['./staff-competency-list.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed, void', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
      transition('expanded <=> void', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)'))
    ]),
  ],
})
export class StaffCompetencyListComponent implements OnInit {
  @Input('compType') competencyType
  competencyData: any = []
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort;
  displayedColumns = ['name', 'title', 'recertificationDate', 'assessmentDate', 'status']
  pageSizeOptions: number[] = [25, 50, 100];
  noDataMsg = {
    title: "No Competencies!",
    data: "You have not assign any competency to user"
  }
  filterActive: boolean = false
  afterFilter
  loading: boolean = false;
  searchText
  tempDataSource: any;
  competencyStatus = competencyStatusLists
  statusArray = [];
  noFiles = {
    title: "No Files!",
    data: "No files added yet!"
  }
  userList
  competencyModule
  isExpansionDetailRow = (i: number, row: Object) => row.hasOwnProperty('expandedDetail');
  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public _staffService: StaffService,
    public _utilityService: UtilityService,
    public _filter: FilterService,
    public _assetService: AssetService,
    public _competencyService: CompetenciesService,
  ) {
    this.dataSource = new MatTableDataSource(this.competencyData)
    this._competencyService.newAddedCompetency.subscribe((compData) => {
      console.log("ADDED NEW COMPETENCY", compData)
      if (compData && this.competencyType) {
        // this.getStaffwiseCompetency()
        compData.map(data => {
          data.competencies && data.competencies.map(comp => {
            this.competencyData.push({ name: data.name, Id: comp.instructor, ...comp })
          })
        })
        this.updateData(this.competencyData)
      }
    })
  }

  ngOnInit() {
    this.getStaffwiseCompetency()
  }

  updateData(comp) {
    console.log("UPDATING DATA  for competency= ", comp)
    let tempArray = []
    tempArray = comp
    this.dataSource = new MatTableDataSource(tempArray);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sortingDataAccessor = (item, property) => {
      switch (property) {
        case 'recertificationDate': return new Date(item.recertificationDate);
        default: return item[property];
      }
    };
    this.dataSource.sort = this.sort;
    // console.log("SETTING SORT TO = ", this.dataSource.sort)
    // console.log("SETTING paginator TO = ", this.dataSource.paginator)
    this.loading = false;
  }

  filter(searchText) {
    this.afterFilter = null
    this.filterActive = false;
    console.log('FILTER CALLED', searchText);
    if (searchText === '') {
      this.updateData(this.competencyData);
      return;
    }
    console.log("filter Time pass data..", this.competencyData)
    let data = this.competencyData
    this.tempDataSource = this._filter.filter1(searchText, data, ['name', 'title', 'sentinelNumber']);
    this.updateData(this.tempDataSource)
    console.log("tempDataSource-->", this.tempDataSource, this.loading, this.filterActive);
    if (this.tempDataSource.length <= 0) {
      this.filterActive = true;
      this.afterFilter = {
        title: "No Competencies!",
        data: "Sorry, no competencies matched your search"
      }
    }
  }
  selectedStatus(event) {
    console.log("status of checked event", event);
    this.filterActive = false
    const finalarray = [];
    if (this.statusArray.length) {
      this.competencyData.forEach((e1) => this.statusArray.forEach((e2) => {
        if (e1.status == e2) {
          finalarray.push(e1)
        }
      }));
      this.updateData(finalarray);
    } else this.updateData(this.competencyData)
    if (finalarray.length == 0 && this.statusArray.length != 0) {
      this.filterActive = true
      this.afterFilter = {
        title: "No Competencies!",
        data: "Sorry, no competencies matched your search"
      }
    }
  }

  getRandomColorClass(i) {

    return this._utilityService.getCommonRandomColorClass(i)
    console.log("what is temp", i);
    // return temp
  }

  fileDetails(event) {
    this._assetService.displayFile(event)
  }

  getStaffwiseCompetency() {
    this.loading = true
    this._staffService.getAllStaff().subscribe((res) => {
      console.log("res.............", res.data.instructors);
      res.data.instructors.map(data => {
        if (!data.isArchive) {
          data.competencies && data.competencies.map(comp => {
            this.competencyData.push({ name: data.name, Id: comp.instructor, sentinelNumber: data.sentinelNumber, ...comp })
          })
        }
      })
      this.updateData(this.competencyData)
    })
  }

}
